import type { LatestUpdatesProductUpdate } from './types';

const FIRST_IMG_SRC_REGEX = /<img[^>]+src=["']([^"']+)["']/i;

export const getProductUpdatePreviewImageUrl = (
  update: LatestUpdatesProductUpdate,
): string | null => {
  if (update.featured_image?.thumbnail) {
    return update.featured_image.thumbnail;
  }

  if (update.featured_image?.url) {
    return update.featured_image.url;
  }

  const match = update.content?.match(FIRST_IMG_SRC_REGEX);
  return match?.[1] ?? null;
};
